<template>
  <div v-if="dataInfo" class="account">
    <div class="account-header">
      <account-user :dataInfo="dataInfo" />
    </div>

    <div class="account-main">
      <my-cards v-if="cardInfos.length" :topDataInfo="cardInfos" />
      <!-- <div class="account-main-customer">
        <van-cell v-if="dataInfo.isWaterUser" @click="gotoBindCustomer">
          <div class="amc-bind">
            <div>
              <van-image width="44px" height="44px" fit="cover" :src="imgBind" />
              <span class="amc-title">已绑客户</span>
            </div>
            <div>
              <span class="amc-number">{{ bindCustomerNumber }}人</span>
              <van-image width="44px" height="44px" fit="cover" :src="imgArrow" />
            </div>
          </div>
        </van-cell>
        <van-cell @click="gotoInvoice">
          <div class="amc-bind">
            <div>
              <van-image width="44px" height="44px" fit="cover" :src="imgInvoice" />
              <span class="amc-title">电子发票</span>
            </div>
            <div>
              <van-image width="44px" height="44px" fit="cover" :src="imgArrow" />
            </div>
          </div>
        </van-cell>
      </div> -->
      <!-- 抄表记录暂时去掉，后续再接入 -->
      <div class="invoice-select" @click="showPopup">
        <div class="clickSelect">
          <van-dropdown-menu active-color="#1677FF">
            <van-dropdown-item :title="mrMonth" ref="yearTwo">
              <!-- <drop-down-selection
                      :currentValue="currentIndex"
                      :dataValArr="yearList"
                      @getSelectValue="showPopup"
                    /> -->
            </van-dropdown-item>
          </van-dropdown-menu>
        </div>
        <div class="showSelect">账单年月</div>
      </div>
      <div class="account-main-line">
        <!-- <line-chart chartId="equip-chart" :option="chartOption" /> -->
        <!-- <table-record></table-record> -->

        <ul class="table-box payment-table" v-if="paymentRecords.length">
          <li class="table-head">
            <!-- <div class="table-title">账单记录</div> -->
            <div
              class="current-author-payInfo"
              v-for="(item, index) in paymentRecords"
              :key="item.key"
            >
              <div class="van-ellipsis">
                <span>出账日期 : </span>
                <span>{{ item.buildTime }}</span>
              </div>
              <div class="van-ellipsis">
                <span>出账原因 : </span>
                <span>{{ item.recCause }}</span>
              </div>
              <div v-if="item.meterCode" class="van-ellipsis">
                <span>表身码 : </span>
                <span>{{ item.meterCode }}</span>
              </div>
              <div class="van-ellipsis">
                <span>账单金额 :</span> <span>{{ item.arreWithLateFee }}</span>
              </div>
              <div class="van-ellipsis">
                <span>上次抄表读数 :</span> <span>{{ item.mrStartCode }}</span>
              </div>
              <div class="van-ellipsis">
                <span>本次抄表读数 :</span> <span>{{ item.mrStopCode }}</span>
              </div>
              <div class="van-ellipsis">
                <span>用水量 :</span> <span>{{ item.chargeCount }}</span>
              </div>
              <div class="van-ellipsis">
                <span>是否完成缴费 :</span> <span>{{ item.paid }}</span>
              </div>
            </div>
            <!-- <div class="table-colums">
              <span
                v-for="item in payColums"
                :key="item.key"
              >
                {{ item.title }}
              </span>
            </div> -->
          </li>
          <!-- <li class="table-data">
            <ul
              v-for="(item, index) in paymentRecords"
              :key="index"
              :class="{'table-item': true, 'black-bg': index % 2 === 1 }"
            >
              <li
                v-for="(keyName, kIndex) in item"
                :key="kIndex">
                <span> {{ keyName }} </span>
              </li>
            </ul>
          </li> -->
        </ul>

        <div v-else class="no-data-box">
          <div>账单记录</div>
          <no-data />
        </div>
      </div>

      <!-- <div class="account-main-line">
        <ul class="table-box meter-table" v-if="meterRecords.length">
          <li class="table-head">
            <div class="table-title">抄表记录</div>
            <div class="table-colums">
              <span
                v-for="item in meterColums"
                :key="item.key"
                :title="item.title"
              >
                {{ item.title }}
              </span>
            </div>
          </li>
          <li class="table-data">
            <ul
              v-for="(item, index) in meterRecords"
              :key="index"
              :class="{'table-item': true, 'black-bg': index % 2 === 1 }"
              @click="getCurrentRow(item, false)"
            >
              <li
                v-for="(keyName, kIndex) in item"
                :key="kIndex"
              >
                <span> {{ keyName }} </span>
              </li>
            </ul>
          </li>
        </ul>

        <div v-else class="no-data-box">
          <div>抄表记录</div>
          <no-data />
        </div>
      </div> -->
      <div class="account-main-water" v-if="countCompare.yearChargeCount">
        <div class="detail-box">
          <h3 class="title strong">年度用水小结</h3>
          <div class="value">
            <!-- <view class="">{{ selectTime.slice(0, 4) }}年度，</view> -->
            <p class="">
              用水量最高的月份为{{
                countCompare.maxWaterUse.month || "--"
              }}月，用水量{{ countCompare.maxWaterUse.chargeCount || 0 }}吨，
            </p>
            <p class="">
              比去年同期增长{{
                countCompare.maxWaterUse.percent || "--"
              }}，产生水费{{ countCompare.maxWaterUse.chargeAmount || 0 }}元。
            </p>
            <p class="">
              用水量最低的月份为{{
                countCompare.minWaterUse.month || "--"
              }}月，用水量{{ countCompare.minWaterUse.chargeCount || 0 }}吨，
            </p>
            <p class="">
              比去年同比增长{{
                countCompare.minWaterUse.percent || "--"
              }}，产生水费{{ countCompare.minWaterUse.chargeAmount || 0 }}元。
            </p>
            <p class="">
              年累计用水{{ countCompare.yearChargeCount || "0" }}吨，月均{{
                countCompare.monthChargeCount || "0"
              }}吨。
            </p>
            <p class="">
              年累计水费{{ countCompare.yearChargeAmount || "0" }}元，月均{{
                countCompare.monthChargeAmount || "0"
              }}元。
            </p>
          </div>
        </div>
      </div>

      <van-popup
        v-model:show="showRecords"
        :style="{ height: `${isPayment ? '35%' : '40%'}` }"
      >
        <ul class="records-box">
          <li>
            <span
              class="records-label"
              v-for="(item, index) in currentLabel"
              :key="index"
            >
              {{ item + "：" }}
            </span>
          </li>
          <li>
            <span
              class="records-item"
              v-for="(keyName, kIndex) in currentRow"
              :key="kIndex"
            >
              {{ keyName === "string" && !keyName ? "无" : keyName }}
            </span>
          </li>
        </ul>
      </van-popup>

      <!-- 弹出框 -->
      <!--  -->

      <van-popup
        class="popup-content"
        get-container="#bind"
        close-icon-position="top-left"
        position="bottom"
        v-model="show"
        round
        closeable
        :style="{ height: '60%' }"
      >
        <div class="title">
          <p>请选择账单月份</p>
          <!-- <span>需为最近一年账单</span> -->
        </div>
        <bottom-selection
          :dataValArr="monthData"
          @getSelectValue="getSelectValueInfo"
        />
      </van-popup>
    </div>
    <div class="account-foot">
      <van-button round block @click="handerUnbind" type="danger"
        >解除绑定</van-button
      >
    </div>
  </div>
</template>

<script>
const payColums = [
  {
    title: "出账日期",
    key: "mrLocaldate",
  },
  {
    title: "账单金额",
    key: "arreWithLateFee",
  },

  {
    title: "上次读数",
    key: "mrStartCode",
  },
  {
    title: "本次读数",
    key: "mrStopCode",
  },
  {
    title: "用水量",
    key: "chargeCount",
  },
  {
    title: "是否完成缴费",
    key: "paid",
  },
];

const paymentRecords = [];
for (let i = 0; i < 20; i++) {
  paymentRecords.push({
    // id: i,
    payTime: "2022-03-11",
    cciPayAmount: "￥100",
    // cciChargeStaffName: '微信',
    cciFact: "￥90",
    cciPrestoreBalance: "￥13.5",
    recCause: "",
    buildTime: "",
    meterCode: "",
  });
}

const meterColums = [
  {
    title: "用户编号",
    key: "clientCode",
  },
  {
    title: "抄表日期",
    key: "mrMonth",
  },
  // {
  // 	title: '抄表员',
  // 	key: 'chargeCheckStaff',
  // },
  {
    title: "违约金",
    key: "lateFee",
  },
  // {
  // 	title: '是否已缴',
  // 	key: 'chargeCancelState',
  // },
  {
    title: "计费水量",
    key: "chargeCount",
  },
  {
    title: "应收金额",
    key: "chargeAmount",
  },
];

const meterRecords = [];
for (let i = 0; i < 20; i++) {
  meterRecords.push({
    // id: i,
    meterCode: "22121",
    chargeCheckTime: "2022-03-11",
    chargeCheckStaff: "张三",
    startToEnd: "1050-1450",
    chargeCancelState: "否",
    chargeCount: "40000000000",
    chargeAmount: "￥550",
  });
}

import { Dialog } from "vant";
import AccountUser from "./module/AccountUser";
import TableRecord from "./module/TableRecord";
import NoData from "@/components/noData";
import LineChart from "@/components/chart/LineChart";
import LabelTag from "@/components/labelTag";
import { formatTime } from "@/utils/tools";
import { chartOption } from "./module/chartConfig";
import MyCards from "./module/MyCards"; // 我的用水-已绑定
import BottomSelection from "./bottomSelection";
import store from "@/store";
const ImgBind = require("../../assets/icon/icon_绑定.png");
const ImgArrow = require("../../assets/icon/icon_箭头.png");
const ImgInvoice = require("../../assets/icon/icon_发票.png");

import {
  selectOneWaterStatistics,
  selectWuserNoCust,
  updateLabel,
  unbindUser,
  selectRechargeRecord,
} from "../../api/home";

import {
  selectWaterUserDetails,
  meterReadList,
  cardInfos,
  payDetails,
  queryChargeCountCompare,
  getUnBind,
  waterArrearDetails,
  arrearInfos,
} from "../../api/user";
import { Toast } from "vant";

export default {
  components: {
    AccountUser,
    MyCards,
    LineChart,
    LabelTag,
    TableRecord,
    BottomSelection,
    NoData,
  },
  data() {
    return {
      imgBind: ImgBind,
      imgArrow: ImgArrow,
      imgInvoice: ImgInvoice,
      chartOption,
      bindCustomerNumber: "",
      tagValue: this.$route.query.labelName,
      labelName: this.$route.query.labelName,
      clientCode: this.$route.query.clientCode,
      // isWaterUser: false,
      dataInfo: null,
      payColums,
      paymentRecords: [],
      meterColums,
      meterRecords: [],
      showRecords: false,
      cardInfos: [],
      currentRow: null,
      currentLabel: [],
      isPayment: true,
      countCompare: {},
      show: false,
      monthData: [],
      currentMounth: "",
      mrMonth: "",
      currentIndex: 0,
      yearList: [],
    };
  },
  mounted() {
    // this.isWaterUser = this.$route.query  && this.$route.query.isWaterUser === true ? true : false;
    /* this.chartOption.series = [
      {
        name: '今年',
        type: 'line',
        symbolSize: 4,
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: this.chartOption.color[0] },
              { offset: 1, color: 'rgba(255,255,255,0)' },
            ],
            global: false, // 缺省为 false
          },
        },
        data: [],
      },
      {
        name: '去年',
        type: 'line',
        symbolSize: 4,
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: this.chartOption.color[1] },
              { offset: 1, color: 'rgba(255,255,255,0)' },
            ],
            global: false, // 缺省为 false
          },
        },
        data: [],
      },
      {
        name: '前年',
        type: 'line',
        symbolSize: 4,
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: this.chartOption.color[2] },
              { offset: 1, color: 'rgba(255,255,255,0)' },
            ],
            global: false, // 缺省为 false
          },
        },
        data: [],
      },
    ]; */
    const date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    if (date.getDate() > 20) {
      month += 1;
      if (month > 12) {
        month = 1;
        year += 1;
      }
    }
    this.mrMonth = month > 9 ? `${year}${month}` : `${year}0${month}`;
    this.getMounth();

    this.getDataInfo();
    this.getCardInfo();
    this.getArrearInfo();
    this.getPayMentData();
    this.getMeterData();
    this.getSelectAccount();
  },

  methods: {
    // 选择年份 - 获取年份(12个月份)
    getYear() {
      const date = new Date();
      const year = date.getFullYear();
      for (let i = year - 11; i <= year; i++) {
        this.yearList.push({
          name: i + "年",
        });
      }
      this.yearList.reverse();
    },
    // 选择账单月份
    getMounth() {
      const date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      if (date.getDate() > 20) {
        month += 1;
        if (month > 12) {
          month = 1;
          year += 1;
        }
      }
      let objMonthOne = {};
      let objMonthTwo = {};
      let monthList = [];
      for (let i = 1; i < month + 1; i++) {
        monthList.push({
          name: i + "月",
        });
      }
      objMonthOne.year = year;
      objMonthOne.yearMounth = monthList.reverse();
      this.monthData.push(objMonthOne);
      // 如果当前月份小于12 则加前面一年的月份
      if (month < 12) {
        this.heightFlag = false;
        let preMonthList = [];
        for (let i = 1; i < 13; i++) {
          preMonthList.push({
            name: i + "月",
          });
        }
        const preYear = year - 1;
        objMonthTwo.year = preYear;
        objMonthTwo.yearMounth = preMonthList;
        this.monthData.push(objMonthTwo);
      }
      // else if (month == 12 && day > 21) {
      //   let preMonthList = [{
      //     name: "1月",
      //   }];
      //   const preYear = year + 1;
      //   objMonthTwo.year = preYear;
      //   objMonthTwo.yearMounth = preMonthList;
      //   this.monthData.push(objMonthTwo);
      // }
      console.log("this.monthData", this.monthData);
    },
    showPopup() {
      this.show = true;
    },
    // 选择年-月
    getSelectValueInfo(year, month) {
      // this.dataInfo.month = month;
      let monthString = month.substring(0, month.lastIndexOf("月"));
      this.mrMonth =
        monthString > 9 ? `${year}${monthString}` : `${year}0${monthString}`;
      this.show = false;
      this.getMeterData();
    },
    async getDataInfo() {
      const resArrear = await arrearInfos([this.clientCode]);
      const { status, resultData } = await selectWaterUserDetails(
        this.clientCode
      );
      if (status === "complete") {
        this.dataInfo = {
          ...resultData[0],
          labelName: this.labelName,
          ...resArrear.resultData,
        };
      }
    },

    /**
     * 获取欠费信息
     */
    async getArrearInfo() {
      const { status, resultData } = await waterArrearDetails(this.clientCode);
      if (status === "complete") {
        console.log("欠费信息", resultData);
      }
    },
    async getCardInfo() {
      let arg = {
        clientNo: this.clientCode,
      };
      console.log("获取卡片信息", arg);
      const { status, resultData } = await cardInfos(arg);
      if (status === "complete") {
        this.cardInfos = resultData;
      }
    },
    // 获取缴费记录
    async getPayMentData() {
      let param = {
        clientCode: this.clientCode,
      };
      const { status, resultData } = await payDetails(param);
      if (status === "complete") {
        this.paymentRecords = resultData.map((item) => {
          let obj = {
            payTime: item.jfLocalDateTime,
            cciPayAmount: `￥${item.sjskFee}`,
            // cciChargeStaffName: item.sky,
            cciFact: `￥${item.cciAmount}`,
            cciPrestoreBalance: item.qmyc,
          };
          return obj;
        });
      }
    },
    // 获取抄表记录
    async getMeterData() {
      let param = {
        mrMonth: this.mrMonth,
        userId: store.getters.userInfo.userId,
      };
      const { status, resultData } = await meterReadList(param);
      if (status === "complete") {
        let currentMr = resultData.filter(
          (x) => x.clientCode == this.clientCode
        );
        if (
          currentMr.length &&
          currentMr[0].details &&
          currentMr[0].details.length > 0
        ) {
          this.paymentRecords = currentMr[0].details.map((item) => {
            let obj = {
              mrLocaldate: item.mrLocaldate,
              arreWithLateFee: item.arreWithLateFee,
              recCause: item.recCause,
              buildTime: item.buildTime,
              meterCode: item.meterCode,
              mrStartCode: (+item.mrStartCode || 0).toFixed(0),
              mrStopCode: (+item.mrStopCode || 0).toFixed(0),
              chargeCount: item.chargeCount,
              paid: item.paid === "Y" ? "是" : item.paid === "N" ? "否" : "",
            };
            return obj;
          });
        } else {
          this.paymentRecords = [];
        }

        console.log("账单记录", this.paymentRecords);
      }
    },
    getCurrentRow(row, isPayment) {
      this.isPayment = isPayment;
      const payLabel = [
        "缴费日期",
        "缴费金额",
        "收款员",
        "本次扣款",
        "本次余额",
      ];
      const meterLabel = [
        "用户编号",
        "抄表日期",
        "起止码",
        "是否已缴",
        "计费水量",
        "应收金额",
      ];
      this.currentLabel = isPayment ? payLabel : meterLabel;
      this.currentRow = JSON.parse(JSON.stringify(row));
      this.showRecords = true;
    },
    // 页面请求
    /* async initFn() {
      console.log('1111111111');
      const clientCode = this.clientCode;
      const { status, resultData } = await selectOneWaterStatistics(clientCode);
      if (status === 'complete') {
        // 转换时间
        resultData.finalPayTime = formatTime(resultData.finalPayTime);
        this.tagValue = resultData.labelName;
        this.labelName = resultData.labelName;
        this.clientCode = resultData.clientCode;
        this.dataInfo = resultData;
        console.log('传之前', resultData);

        this.chartOption.xAxis[0].data = [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月',
        ];
        this.chartOption.legend.data = ['今年', '去年', '前年'];
        // 今年数据
        let thisYearListData = [];
        resultData &&
          resultData.thisYearList.map((item) => {
            for (let i in item) {
              thisYearListData.push(item[i]);
            }
          });
        // 去年数据
        let lastYearListData = [];
        resultData &&
          resultData.lastYearList.map((item) => {
            for (let i in item) {
              lastYearListData.push(item[i]);
            }
          });
        // 前年数据
        let beforeLastYearListData = [];
        resultData &&
          resultData.beforeLastYearList.map((item) => {
            for (let i in item) {
              beforeLastYearListData.push(item[i]);
            }
          });
        this.chartOption.series[0].data = thisYearListData;
        this.chartOption.series[1].data = lastYearListData;
        this.chartOption.series[2].data = beforeLastYearListData;
      }
    }, */
    async getSelectAccount() {
      let arg = {
        clientCode: this.clientCode,
        chargeYear: new Date().getFullYear(),
      };
      const { status, resultData } = await queryChargeCountCompare(arg);
      if (status === "complete") {
        if (resultData) {
          let { maxWaterUse, minWaterUse } = resultData;
          (maxWaterUse = maxWaterUse ? maxWaterUse : {}),
            (minWaterUse = minWaterUse ? minWaterUse : {});
          console.log(maxWaterUse, minWaterUse);
          maxWaterUse.month =
            maxWaterUse.chargeMonth && maxWaterUse
              ? Number(maxWaterUse.chargeMonth.slice(5, 7))
              : "--";
          minWaterUse.month =
            minWaterUse.chargeMonth && minWaterUse
              ? Number(minWaterUse.chargeMonth.slice(5, 7))
              : "--";
          maxWaterUse.percent =
            maxWaterUse.lastYearCount > 0
              ? (
                  ((maxWaterUse.chargeCount - maxWaterUse.lastYearCount) /
                    maxWaterUse.lastYearCount) *
                  100
                ).toFixed(2) + "%"
              : "--";
          minWaterUse.percent =
            minWaterUse.lastYearCount > 0
              ? (
                  ((minWaterUse.chargeCount - minWaterUse.lastYearCount) /
                    minWaterUse.lastYearCount) *
                  100
                ).toFixed(2) + "%"
              : "--";
          this.countCompare = resultData;
          console.log(this.countCompare);
        }
      }
    },
    // 修改标签
    getTagValueInfo(msg) {
      this.labelName = msg;
      // this.updateLabel();
    },
    async updateLabel() {
      const arg = {
        clientCode: this.clientCode,
        labelName: this.labelName,
      };
      const { status, resultData } = await updateLabel(arg);
      if (status === "complete") {
        Notify({ type: "success", message: "修改成功" });
      }
    },
    // 解除绑定
    handerUnbind() {
      console.log(this.dataInfo);
      // if (this.dataInfo.bindGroup && this.dataInfo.bindGroup.length > 0) {
      let that = this;
      Dialog.confirm({
        message: "解除绑定后将无法查看该用水账户的信息，您确定解除绑定吗？",
        confirmButtonText: "解除绑定",
        confirmButtonColor: "#3C7EF0",
        cancelButtonText: "不解除",
        cancelButtonColor: "#767E8C",
        className: "removeDialog",
      })
        .then(() => {
          console.log("解除");
          const realUserId = store.getters.userInfo.userId;
          const clientCode = this.dataInfo.clientCode;
          that.unbindUser(realUserId, clientCode);
        })
        .catch(() => {
          console.log("取消");
        });
      // } else {
      //   Toast('请选择标签');
      // }
    },
    async unbindUser(realUserId, clientCode) {
      let param = {
        clientCode: clientCode,
        userId: realUserId,
      };
      const { status, resultData } = await getUnBind(param);
      if (status === "complete") {
        Toast("已解除该客户的绑定");
        this.$router.push({ path: "/" });
      }
    },
    gotoBindCustomer() {
      this.$router.push({
        name: "BindCustomer",
        path: "/WaterAccount/bindCustomer",
        query: {
          clientCode: this.clientCode,
        },
      });
    },
    gotoInvoice() {
      this.$router.push({
        name: "Invoice",
        path: "/Invoice",
        query: {
          clientCode: this.clientCode,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.account {
  width: 100%;
  height: 100vh;
  &-header {
    margin: 16px 8px 0 8px;
  }
  &-main {
    padding-bottom: 50px;
    &-customer {
      border-radius: 8px;
      overflow: hidden;
      margin: 16px 8px 0 8px;
      .van-cell {
        padding: 6px 0 6px 16px;
      }
      .amc-bind {
        display: flex;
        justify-content: space-between;
        align-items: center;
        div {
          display: flex;
          align-items: center;
        }
        .amc-title {
          margin-left: 18px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #333333;
        }
        .amc-number {
          margin-right: 10px;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #4a90e2;
        }
      }
    }
    &-tag {
      background: #ffffff;
      margin: 16px 8px 0 8px;
      border-radius: 8px;
      overflow: hidden;
    }
    &-line {
      border-radius: 8px;
      // overflow: hidden;
      // padding: 16px;
      margin: 0;
      background: #ffffff;
      color: #333;
      font-size: 12px;
    }
    &-water {
      border-radius: 8px;
      margin: 16px 8px;
      background: #ffffff;
      height: 22%;
      color: #333;
      font-size: 12px;
    }
  }
  &-foot {
    display: flex;
    justify-content: center;
    position: fixed;
    bottom: 0;
    padding: 10px 12px;
    width: 94%;
    &-relieve {
      width: 100%;
      margin: 0 16px;
      border-radius: 8px;
      border: none;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
    }
  }

  .table-box {
    height: 100%;
    padding: 1px 15px;
    box-sizing: border-box;

    .table-head {
      font-weight: 700;
      .table-title {
        font-size: 16px;
        text-align: center;
      }
      .table-colums {
        padding-top: 15px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }

    .table-data {
      height: calc(100% - 70px);
      overflow: auto;
      .table-item {
        margin-top: 10px;
        display: flex;
        align-items: center;
        height: 25px;
        line-height: 25px;
        &.black-bg {
          // background: rgba(0, 17, 58, 0.3);
          background-color: #f5f5f5;
        }
        li,
        span {
          overflow: hidden; //超出的文本隐藏
          text-overflow: ellipsis; //溢出用省略号显示
          white-space: nowrap; //溢出则不换行
        }
      }
    }
  }

  .payment-table {
    .table-colums > span:first-child {
      display: inline-block;
      width: 70px;
      text-align: center;
    }
    .table-item {
      justify-content: space-between;
      li {
        width: 70px;
        text-align: center;
        &:first-child {
          width: 30%;
          text-align: left;
        }
        &:last-child > span {
          padding-left: 15px;
        }
      }
    }
  }

  .meter-table {
    .table-colums {
      span:nth-child(3),
      span:nth-child(4) {
        padding-left: 12px;
      }
      span:nth-child(5) {
        padding-left: 10px;
      }
    }
    .table-item {
      justify-content: space-between;
      li {
        // width: 14.29%;
        width: 16.67%;
        text-align: center;
      }
      li:first-child,
      li:nth-child(4) {
        // text-align: left;
      }
      /* li:nth-child(3) {
				padding-left: 5px;
			} */
      /* li:first-child, li:nth-child(6) {
        overflow: hidden; //超出的文本隐藏
				text-overflow: ellipsis; //溢出用省略号显示
				white-space: nowrap; //溢出则不换行
      } */
    }
  }

  .no-data-box {
    height: 100%;
    padding: 15px;
    box-sizing: border-box;
    div:first-child {
      font-size: 16px;
      font-weight: 700;
      text-align: center;
    }
    .noData {
      margin-top: 3% !important;
    }
  }

  .van-popup {
    width: 100%;
  }
  .records-box {
    width: 100%;
    font-size: 14px;
    color: #333;
    display: flex;
    justify-content: center;
    align-items: center;
    li {
      width: 50%;
      height: 20px;
      line-height: 20px;
      display: flex;
      flex-direction: column;
      span {
        padding-top: 20px;
      }
    }
    .records-label {
      text-align: right;
    }
  }
}
.detail-box {
  background-color: #fff;
  line-height: 2;
  .img-box {
    padding: 30px;
  }
  image {
    width: 100%;
  }
  .title {
    margin: 5px 0;
  }
  .value {
    p {
      margin: 2px 0;
    }
  }
}
.detail-box {
  padding: 10px;
}
/deep/.van-dropdown-menu__bar {
  height: auto;
  background: transparent;
  box-shadow: none;
}

.invoice-select {
  height: 50px;
  background: #fff;
}

.showSelect {
  position: relative;
  float: left;
  top: 0px;
  width: 33%;
  line-height: 50px;
  padding-left: 20px;
}
.clickSelect {
  float: right;
  width: 60%;
}
.popup-content {
  .title {
    border-bottom: 1px solid #eeeeee;
    padding-top: 12px;
    padding-bottom: 12px;
    p {
      font-family: PingFangSC-Medium;
      font-size: 18px;
      color: #333333;
      text-align: center;
      line-height: 26px;
      margin: 0px;
    }
  }
  .content {
    /deep/.van-field__control {
      height: 45px;
      background-color: #f9f8f8;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      letter-spacing: 0;
      text-indent: 1em;
    }
    .btn {
      margin-left: 16px;
      margin-right: 16px;
      margin-top: 30px;
      display: flex;
      justify-content: space-between;
      .cancelBtn {
        width: 125px;
        height: 44px;
        border-radius: 4px;
        background: #f6f6f6;
        color: #4285f4;
      }
      .sendBtn {
        width: 125px;
        height: 44px;
        border-radius: 4px;
      }
    }
    .email-list {
      margin: 16px;
      max-height: 200px;
      // overflow-y: scroll;
      ul {
        li {
          height: 28px;
          line-height: 28px;
        }
      }
    }
  }
  .content-i {
    /deep/.van-cell__title {
      text-align: center;
    }
    /deep/.van-radio__label {
      width: 90%;
    }
    /deep/.van-radio__icon .van-icon {
      border: 0px solid transparent;
    }
    /deep/.van-radio__icon--checked .van-icon {
      background-color: transparent;
      border-color: transparent;
      color: #1989fa;
    }
    /deep/.van-radio {
      position: relative;
      margin: 0px 16px;
      border-bottom: 1px solid #eeeeee;
    }
    /deep/.van-radio__icon {
      position: absolute;
      right: 0px;
    }
    .van-cell {
      padding-left: 0px;
    }
    .btn {
      margin-left: 16px;
      margin-right: 16px;
      margin-top: 30px;
      display: flex;
      justify-content: space-between;
      .cancelBtn {
        width: 125px;
        height: 44px;
        border-radius: 4px;
        background: #f6f6f6;
        color: #4285f4;
      }
      .sendBtn {
        width: 125px;
        height: 44px;
        border-radius: 4px;
      }
    }
  }
}

/deep/.van-dropdown-menu__item {
  background: #5f97f4;
  border-radius: 10px;
  height: 50px;
  .van-dropdown-menu__title {
    color: #fff;
  }
}
.van-dropdown-menu__title {
  color: #fff;
}
.payment-table {
  .current-author-payInfo {
    margin: 3px 15px 0px 5px;
    padding-top: 5px;
    padding-bottom: 5px;
    text-align: left;
    position: relative;
    border-bottom: 1px solid #eee;
    div {
      display: flex;
      height: 35px;
      line-height: 35px;
      width: calc(100% - 5px);
      // padding-bottom: 4px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #5c6775;
      letter-spacing: -0.36px;
      vertical-align: middle;
      align-items: center;
      justify-content: space-between;
      // border-bottom: 1px solid #eee;
    }
  }
}
</style>
